import { IcoMoonIcon } from '@wwe-portal/ui/components/icons';
import { cn } from '@wwe-portal/ui/lib/lib';
import { tryFormatThousands } from '@wwe-portal/utils/format';
import { FC } from 'react';

export interface RosterUpgradesAndWinsProps {
  upgrades: { last30days: string | undefined; allTime: string | undefined };
  wins: {
    last30days: string | undefined;
    allTime: string | undefined;
  };
}

export const RosterUpgradesAndWins: FC<RosterUpgradesAndWinsProps> = ({
  upgrades,
  wins,
}) => {
  return (
    <div className="w-full rounded-lg px-8 pt-4 text-white">
      <div className="grid grid-cols-2 gap-x-8">
        {/* Headers Row */}
        <div className="mb-2 ml-9">
          <h2 className="text-green700 text-base font-semibold italic">
            UPGRADES
          </h2>
        </div>
        <div className="mb-2 ml-9">
          <h2 className="text-green700 text-base font-semibold italic">WINS</h2>
        </div>

        {/* Upgrades 30 days */}
        <DataRow
          iconColor="text-blue500"
          value={upgrades.last30days}
          label="Last 30 Days"
        />

        {/* Wins 30 days */}
        <DataRow
          iconColor="text-yellow800"
          value={wins.last30days}
          label="Last 30 Days"
        />

        {/* Upgrades All Time */}
        <DataRow
          iconColor="text-blue500"
          value={upgrades.allTime}
          label="All Time"
        />

        {/* Wins All Time */}
        <DataRow
          iconColor="text-yellow800"
          value={wins.allTime}
          label="All Time"
        />
      </div>
    </div>
  );
};

const DataRow = ({
  iconColor,
  value,
  label,
}: {
  iconColor: string;
  value: string | undefined;
  label: string;
}) => {
  return (
    <div className="mb-4 font-semibold italic">
      <div className="flex items-center gap-3">
        <IcoMoonIcon
          iconName="compass-empty"
          className={cn('h-6 w-6', iconColor)}
        />
        <span className="text-text400 text-base">
          {value == null ? '???' : tryFormatThousands(value)}
        </span>
      </div>
      <div className="text-text600 ml-9 mt-1 text-sm">{label}</div>
    </div>
  );
};
